import React from 'react'
import './InputTypeCheckBox.css'
import { Icon } from '@iconify/react'
const InputCheckBox = () => {
    const handleOnClick = ()=>{
        const input = document.getElementsByClassName('input-type-checkbox')[0]
        input.checked = false
    }  
    return (
        <div className='checkbox-container'>
            <input type='checkbox' className='input-type-checkbox'/>
            <Icon className='check-icon' icon='material-symbols:check' onClick={handleOnClick}/>
        </div>
    )
}

export default InputCheckBox